import React, { Component } from "react";
import { connect } from "react-redux";
import {} from "../../redux/app/actions";
import {} from "../../redux/csDsp/actions";
import {} from "../../redux/ui/actions";
import {
    addWLTrAction,
    addPompTrAction,
    updateWLTrAction,
    updatePompTrAction,
    changeWLTrSelRowAction,
    changePompTrSelRowAction,
    changeMeaSelRowAction,
    changeMeaTimeSelRowAction,
} from "../../redux/well/actions";
import Lgd, { probLgd } from "../common/Lgd";
import Sw from "../common/Sw";

const mapStateToProps = (state) => {
    return {
        wlTrData: state.wellReducer.wlTrData,
        pompTrData: state.wellReducer.pompTrData,
        meaSelRow: state.wellReducer.meaSelRow,
        meaTimeSelRow: state.wellReducer.meaTimeSelRow,
    };
};

class Mea extends Component {
    constructor(props) {
        super(props);
    }
    /*
     * 追加
     * @since ando 2023-8-10
     */
    addCat() {
        if (this.props.meaSelRow.indexOf("wl") != -1) {
            const rowID = Number(this.props.meaSelRow.split("wl")[1]);
            const selWLTrData = this.props.wlTrData[rowID];
            const updatedWLTrMeaData = selWLTrData.data.concat({ time: "", mea: "" });
            const updatedWLTrData = this.props.wlTrData.map((el, i) => {
                if (i === rowID) {
                    return { ...el, ["data"]: updatedWLTrMeaData };
                }
                return el;
            });
            // 新しい wellsTrData をセット
            this.props.dispatch(updateWLTrAction(updatedWLTrData));
        } else {
            const rowID = Number(this.props.meaSelRow.split("pomp")[1]);
            const selPompTrData = this.props.pompTrData[rowID];
            const updatedPompTrMeaData = selPompTrData.data.concat({ time: "", mea: "" });
            const updatedPompTrData = this.props.pompTrData.map((el, i) => {
                if (i === rowID) {
                    return { ...el, ["data"]: updatedPompTrMeaData };
                }
                return el;
            });
            // 新しい wellsTrData をセット
            this.props.dispatch(updatePompTrAction(updatedPompTrData));
        }
    }
    /*
     * 行削除
     * @since ando 2024-03-27
     */
    deleteSel() {
        if (this.props.meaSelRow.indexOf("wl") != -1) {
            const rowID = Number(this.props.meaSelRow.split("wl")[1]);
            const selWLTrData = this.props.wlTrData[rowID];
            const updatedWLTrMeaData = selWLTrData.data.filter((el, i) => i != this.props.meaTimeSelRow);
            const updatedWLTrData = this.props.wlTrData.map((el, i) => {
                if (i === rowID) {
                    return { ...el, ["data"]: updatedWLTrMeaData };
                }
                return el;
            });
            // 新しい wellsTrData をセット
            this.props.dispatch(updateWLTrAction(updatedWLTrData));
        } else {
            const rowID = Number(this.props.meaSelRow.split("pomp")[1]);
            const selPompTrData = this.props.pompTrData[rowID];
            const updatedPompTrMeaData = selPompTrData.data.filter((el, i) => i != this.props.meaTimeSelRow);
            const updatedPompTrData = this.props.pompTrData.map((el, i) => {
                if (i === rowID) {
                    return { ...el, ["data"]: updatedPompTrMeaData };
                }
                return el;
            });
            // 新しい wellsTrData をセット
            this.props.dispatch(updatePompTrAction(updatedPompTrData));
        }
    }

    /*
     * テーブルクリック
     * @since ando 2024-07-29
     */
    changeRow = (e) => {
        e.target.closest("tbody").childNodes.forEach((el) => {
            el.classList.remove("selRow");
        });
        const tr = e.target.closest("tr");
        tr.classList.add("selRow");
        this.props.dispatch(changeMeaTimeSelRowAction(tr.id));
        console.log(`Row ${tr.id} clicked!`);
    };

    /*
     * テーブルデータ書き換え
     * @since ando 2024-07-29
     */
    changeField = (e, index, field) => {
        // 例えば、選択された種別を取得する処理などを追加
        const changeField = e.target.value;
        if (isNaN(changeField) && field != "name") {
            alert("数値を入力してください。");
            return;
        }
        if (this.props.meaSelRow.indexOf("wl") != -1) {
            const rowID = Number(this.props.meaSelRow.split("wl")[1]);
            const selWLTrData = this.props.wlTrData[rowID];
            const updatedMeaTrData = selWLTrData.data.map((el, i) => {
                if (i === index) {
                    return { ...el, [field]: changeField };
                }
                return el;
            });
            const updatedWLTrData = this.props.wlTrData.map((el, i) => {
                if (i === rowID) {
                    return { ...el, ["data"]: updatedMeaTrData };
                }
                return el;
            });
            console.log(updatedWLTrData);
            // 新しい wellsTrData をセット
            this.props.dispatch(updateWLTrAction(updatedWLTrData));
        } else {
            const rowID = Number(this.props.meaSelRow.split("pomp")[1]);
            const selPompTrData = this.props.pompTrData[rowID];
            const updatedMeaTrData = selPompTrData.data.map((el, i) => {
                if (i === index) {
                    return { ...el, [field]: changeField };
                }
                return el;
            });
            const updatedPompTrData = this.props.pompTrData.map((el, i) => {
                if (i === rowID) {
                    return { ...el, ["data"]: updatedMeaTrData };
                }
                return el;
            });
            console.log(updatedPompTrData);
            // 新しい wellsTrData をセット
            this.props.dispatch(updatePompTrAction(updatedPompTrData));
        }
    };

    render() {
        return (
            <div>
                <Sw title="計測値" focusName="wells">
                    <div className="l-flex">
                        <button className="sBtn" onClick={() => this.addCat()}>
                            追加
                        </button>
                        <button className="sBtn" onClick={() => this.deleteSel()}>
                            削除
                        </button>
                    </div>
                    <div className="MeaInput l-mtSSS" style={{ overflowY: "scroll" }}>
                        <table className="idoTable">
                            <thead>
                                <tr>
                                    <th className="tsS">時間</th>
                                    <th className="tsS">計測値</th>
                                </tr>
                            </thead>
                            {this.props.meaSelRow.indexOf("wl") != -1 && (
                                <tbody ref={(ref) => (this.tbRef = ref)}>
                                    {this.props.wlTrData !== undefined &&
                                        this.props.wlTrData[Number(this.props.meaSelRow.split("wl")[1])].data.map((el, index) => (
                                            <tr id={index} key={index} onClick={(e) => this.changeRow(e, 0)}>
                                                <td>
                                                    <input className="textTR" type="text" value={el.time} onChange={(e) => this.changeField(e, index, "time")} />
                                                </td>
                                                <td>
                                                    <input className="textTR" type="text" value={el.mea} onChange={(e) => this.changeField(e, index, "mea")} />
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            )}
                            {this.props.meaSelRow.indexOf("pomp") != -1 && (
                                <tbody ref={(ref) => (this.tbRef = ref)}>
                                    {this.props.pompTrData !== undefined &&
                                        this.props.pompTrData[Number(this.props.meaSelRow.split("pomp")[1])].data.map((el, index) => (
                                            <tr id={index} key={index} onClick={(e) => this.changeRow(e, 0)}>
                                                <td>
                                                    <input className="textTR" type="text" value={el.time} onChange={(e) => this.changeField(e, index, "time")} />
                                                </td>
                                                <td>
                                                    <input className="textTR" type="text" value={el.mea} onChange={(e) => this.changeField(e, index, "mea")} />
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            )}
                        </table>
                    </div>
                </Sw>
            </div>
        );
    }
}

export default connect(mapStateToProps)(Mea);
